var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPinWithFlag = function SvgPinWithFlag(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70.12,
    height: 70,
    viewBox: "0 0 70.12 70",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1220",
    "data-name": "Group 1220",
    transform: "translate(-1288 -5399)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_113",
    "data-name": "Ellipse 113",
    transform: "translate(1288 5454)",
    fill: "none",
    stroke: "#fc7600",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.5,
    cy: 7.5,
    rx: 22.5,
    ry: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.5,
    cy: 7.5,
    rx: 22,
    ry: 7,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_870",
    "data-name": "Group 870",
    transform: "translate(1012.513 5075.193)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(283.487 363.938)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_020---Stadium",
    "data-name": "020---Stadium",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M29.059,44.111c0,1.6-6.279,3.386-14.03,3.386S1,45.712,1,44.111c0-.668,1.088-1.282,2.912-1.771v0a.188.188,0,0,0-.01.073c0,.9,2.791,1.945,6.773,2.409.619.077,1.263.135,1.935.174.779.053,1.587.077,2.419.077,1.006,0,1.979-.039,2.9-.111.672-.048,1.321-.116,1.935-.2,3.72-.493,6.289-1.485,6.289-2.351a.188.188,0,0,0-.01-.073v0C27.971,42.829,29.059,43.443,29.059,44.111Z",
    transform: "translate(-0.516 -21.857)",
    fill: "#2e2e2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    d: "M40.343,42.34v0a.188.188,0,0,1,.01.073.6.6,0,0,1-.138.353c1.009.4,1.589.856,1.589,1.34,0,1.551-5.891,3.274-13.3,3.381q.361.005.726.005c7.75,0,14.03-1.785,14.03-3.386C43.255,43.443,42.167,42.829,40.343,42.34Z",
    transform: "translate(-14.712 -21.857)",
    fill: "#2e2e2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-3",
    "data-name": "Shape",
    d: "M29.059,15.328l-.044.329c-.179.484-.822.939-1.8,1.345a7.17,7.17,0,0,0-2.854-1.4,26.592,26.592,0,0,0-3.677-.779,37.508,37.508,0,0,0-3.89-.368c-.581-.024-1.171-.039-1.756-.039s-1.176.015-1.756.039a37.508,37.508,0,0,0-3.89.368,26.592,26.592,0,0,0-3.677.779A7.106,7.106,0,0,0,2.858,17c-.982-.406-1.625-.861-1.8-1.345l-.044-.329C1.15,13.485,8.16,12,15.035,12s13.884,1.485,14.025,3.328Z",
    transform: "translate(-0.521 -6.195)",
    fill: "#666bf1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-4",
    "data-name": "Shape",
    d: "M1,18.88l.044.329A.745.745,0,0,1,1,18.938.236.236,0,0,1,1,18.88Z",
    transform: "translate(-0.516 -9.746)",
    fill: "#0377bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-5",
    "data-name": "Shape",
    d: "M29.183,19.583a18.32,18.32,0,0,1-3.217.919,11.651,11.651,0,0,0-2.38-.6c-.755-.121-1.611-.227-2.52-.31-.871-.077-1.79-.131-2.729-.155-.44-.015-.885-.019-1.33-.019s-.89,0-1.33.019c-.939.024-1.858.077-2.729.155-.91.082-1.766.189-2.52.31a11.737,11.737,0,0,0-2.38.6,18.32,18.32,0,0,1-3.217-.919,7.106,7.106,0,0,1,2.854-1.4,26.592,26.592,0,0,1,3.677-.779,37.508,37.508,0,0,1,3.89-.368c.581-.024,1.171-.039,1.756-.039s1.176.015,1.756.039a37.508,37.508,0,0,1,3.89.368,26.592,26.592,0,0,1,3.677.779,7.17,7.17,0,0,1,2.854,1.4Z",
    transform: "translate(-2.493 -8.776)",
    fill: "#7f8e94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-6",
    "data-name": "Shape",
    d: "M29.4,23.084a45.676,45.676,0,0,1-8.96.851,45.676,45.676,0,0,1-8.96-.851,11.737,11.737,0,0,1,2.38-.6c.755-.121,1.611-.227,2.52-.31.871-.077,1.79-.131,2.729-.155.44-.015.885-.019,1.33-.019s.89,0,1.33.019c.939.024,1.858.077,2.729.155.91.082,1.766.189,2.52.31a11.651,11.651,0,0,1,2.38.6Z",
    transform: "translate(-5.926 -11.357)",
    fill: "#666bf1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-7",
    "data-name": "Shape",
    d: "M58.948,18.938a.745.745,0,0,1-.048.271l.044-.329A.236.236,0,0,1,58.948,18.938Z",
    transform: "translate(-30.406 -9.746)",
    fill: "#0377bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-8",
    "data-name": "Shape",
    d: "M29.062,19.56l0,.039v0L26.2,30.58v0a.188.188,0,0,1,.01.073c0,.866-2.569,1.858-6.289,2.351V30.9a3.876,3.876,0,0,0-3.87-3.87H14.6a3.876,3.876,0,0,0-3.87,3.87v2.167c-3.981-.464-6.773-1.509-6.773-2.409a.188.188,0,0,1,.01-.073v0L1.1,19.6v0l0-.039c.179.484.822.939,1.8,1.345a18.32,18.32,0,0,0,3.217.919,45.676,45.676,0,0,0,8.96.851,45.676,45.676,0,0,0,8.96-.851,18.32,18.32,0,0,0,3.217-.919c.982-.406,1.625-.861,1.8-1.345Z",
    transform: "translate(-0.568 -10.097)",
    fill: "#666bf1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-9",
    "data-name": "Shape",
    d: "M47.35,20.9l-2.521,9.685a.188.188,0,0,1,.01.073c0,.748-1.919,1.589-4.838,2.122v.229c3.72-.493,6.289-1.485,6.289-2.351a.188.188,0,0,0-.01-.073v0L49.139,19.6v0l0-.039C48.965,20.042,48.325,20.5,47.35,20.9Z",
    transform: "translate(-20.649 -10.097)",
    fill: "#0377bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-10",
    "data-name": "Shape",
    d: "M30.322,40.935v2.308c-.924.073-1.9.111-2.9.111-.832,0-1.64-.024-2.419-.077V40.935A1.935,1.935,0,0,1,26.935,39h1.451A1.935,1.935,0,0,1,30.322,40.935Z",
    transform: "translate(-12.906 -20.133)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-11",
    "data-name": "Shape",
    d: "M30.192,38.87v2.109c-.614.082-1.263.15-1.935.2V38.87a1.935,1.935,0,0,0-1.935-1.935H24.87a1.935,1.935,0,0,0-1.935,1.935v2.341c-.672-.039-1.316-.1-1.935-.174V38.87A3.876,3.876,0,0,1,24.87,35h1.451A3.876,3.876,0,0,1,30.192,38.87Z",
    transform: "translate(-10.841 -18.068)",
    fill: "#ffeb3a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_869",
    "data-name": "Group 869",
    transform: "translate(3.87 0.484)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape-12",
    "data-name": "Shape",
    d: "M19,2l3.386,1.451L19,4.9Z",
    transform: "translate(-13.678 -1.516)",
    fill: "#ef314c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-13",
    "data-name": "Shape",
    d: "M52,5l3.386,1.451L52,7.9Z",
    transform: "translate(-30.714 -3.065)",
    fill: "#ef314c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-14",
    "data-name": "Shape",
    d: "M8,5l3.386,1.451L8,7.9Z",
    transform: "translate(-8 -3.065)",
    fill: "#ef314c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-15",
    "data-name": "Shape",
    d: "M41,2l3.386,1.451L41,4.9Z",
    transform: "translate(-25.035 -1.516)",
    fill: "#ef314c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-16",
    "data-name": "Shape",
    d: "M30,1l3.386,1.451L30,3.9Z",
    transform: "translate(-19.357 -1)",
    fill: "#ef314c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Shape-17",
    "data-name": "Shape",
    d: "M8.936,34.776a.484.484,0,0,1-.469-.366L7.016,28.6a.484.484,0,0,1,.939-.235l1.451,5.805a.484.484,0,0,1-.352.587.468.468,0,0,1-.118.015Z",
    transform: "translate(-3.615 -14.458)",
    fill: "#2e2e2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-18",
    "data-name": "Shape",
    d: "M28.733,4.315a.484.484,0,0,0,0-.889L25.347,1.974a.484.484,0,0,0-.674.445V6.434a35.176,35.176,0,0,0-4.354-.764V4.189l3.093-1.326a.484.484,0,0,0,0-.889L20.025.523a.484.484,0,0,0-.674.445v4.6C17.86,5.418,16.364,5.338,15,5.322V3.705L18.09,2.38a.484.484,0,0,0,0-.889L14.7.039a.484.484,0,0,0-.674.445V5.325c-1.367.015-2.863.1-4.354.242V4.189l3.093-1.326a.484.484,0,0,0,0-.889L9.382.523a.484.484,0,0,0-.674.445v4.7a35.176,35.176,0,0,0-4.354.764V5.64L7.447,4.315a.484.484,0,0,0,0-.889L4.061,1.974a.484.484,0,0,0-.674.445V6.7C1.371,7.317,0,8.143,0,9.192a2.572,2.572,0,0,0,.069.435L2.808,20.152C.928,20.718,0,21.406,0,22.254c0,2.315,7.5,3.87,14.513,3.87s14.513-1.555,14.513-3.87c0-.848-.928-1.536-2.806-2.1L28.957,9.627a2.777,2.777,0,0,0,.069-.435c0-1.049-1.371-1.875-3.386-2.49V5.64ZM25.64,3.153l1.674.717-1.674.717ZM20.319,1.7l1.674.717-1.674.717ZM15,1.218l1.674.717L15,2.653ZM9.676,1.7l1.674.717-1.674.717ZM4.354,3.153l1.674.717-1.674.717ZM5.128,9.94l1.521.953a9.184,9.184,0,0,0-1.13.331,22.294,22.294,0,0,1-2.16-.566A9.535,9.535,0,0,1,5.128,9.94Zm3.525-.783.919,1.264c-.538.059-1.051.127-1.528.2L6.4,9.592c.689-.166,1.45-.312,2.252-.436Zm13.981.435-1.645,1.03c-.477-.076-.989-.145-1.528-.2l.919-1.264c.8.125,1.558.27,2.251.436Zm3.036,1.064a22.294,22.294,0,0,1-2.16.566,9.184,9.184,0,0,0-1.13-.331L23.9,9.94a9.535,9.535,0,0,1,1.77.718Zm-11.157.471a41.469,41.469,0,0,1,6.669.509,47.25,47.25,0,0,1-6.669.459,47.25,47.25,0,0,1-6.669-.459A41.47,41.47,0,0,1,14.513,11.127Zm3.826-.813c-.621-.051-1.265-.09-1.922-.116l.253-1.428c.894.048,1.775.128,2.62.233Zm-2.9-.145c-.308-.005-.617-.01-.926-.01s-.619,0-.926.01l-.256-1.441c.394-.013.788-.021,1.182-.021s.789.008,1.182.021Zm-3.084-1.4.253,1.428c-.657.026-1.3.065-1.922.116L9.736,9C10.581,8.9,11.463,8.821,12.356,8.771Zm2.157,4.291c4.418,0,10.433-.7,13.118-2.18l-2.467,9.474a.487.487,0,0,0-.012.213c-.124.458-2.087,1.3-5.319,1.786V20.8a4.359,4.359,0,0,0-4.354-4.354H14.03A4.359,4.359,0,0,0,9.676,20.8v1.62c-3.52-.477-5.677-1.378-5.8-1.858a.484.484,0,0,0-.019-.237L1.4,10.882c2.685,1.479,8.7,2.18,13.118,2.18Zm2.419,9.6c-.765.048-1.571.077-2.419.077-.672,0-1.314-.02-1.935-.051V20.8a1.451,1.451,0,0,1,1.451-1.451h1.451A1.451,1.451,0,0,1,16.932,20.8Zm-1.451-4.277H14.03A2.422,2.422,0,0,0,11.611,20.8v1.822q-.5-.038-.968-.087V20.8a3.39,3.39,0,0,1,3.386-3.386h1.451A3.39,3.39,0,0,1,18.867,20.8v1.684c-.313.037-.636.071-.968.1V20.8A2.422,2.422,0,0,0,15.481,18.384Zm12.578,3.87c0,.887-5.117,2.9-13.546,2.9S.968,23.141.968,22.254c0-.2.454-.677,2.095-1.172.984,1.589,6.379,2.623,11.451,2.623s10.467-1.034,11.451-2.623C27.6,21.577,28.059,22.057,28.059,22.254Zm-.014-13.12c.058.488-.822.913-1.271,1.113-2.362-1.9-9.084-2.506-12.26-2.506-3.141,0-9.828.548-12.26,2.5a5.145,5.145,0,0,1-.732-.387,1.328,1.328,0,0,1-.49-.463c-.258-.54.392-.849.886-1.1,2.994-1.522,9.115-2.006,12.6-2.006A38.464,38.464,0,0,1,26.057,7.857a5.031,5.031,0,0,1,1.73.88A.668.668,0,0,1,28.045,9.134Z",
    transform: "translate(0 0)",
    fill: "#2e2e2e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "danger",
    transform: "translate(221.022 323.345)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1333",
    "data-name": "Path 1333",
    d: "M103.919,51.744s5.79,4.7,15.284,2.58c9-2,17.394-4.271,31.493.821v30.15s-12.968-6.184-24.78-3.426-18.491,1.7-22-1.807",
    transform: "translate(-26.112 -50.809)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_219",
    "data-name": "Rectangle 219",
    width: 2.243,
    height: 52.846,
    transform: "translate(75.959 0.461)",
    fill: "#f03737"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPinWithFlag, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pinWithFlag.0dd32489.svg";
export { ForwardRef as ReactComponent };